import { execOnLoad } from '@general/helpers';
import { throttle } from 'lodash';
import './header.scss';
import { closeModal, openModal } from '@components/modals';
import { afterCartChangeType, getCart } from '@services/cart';
import breakpoints from '../../../.bundler/breakpoints.json';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeader = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const backgroundContainer = sectionContainer.querySelector(
    '.header__background',
  );

  const announcementBarHeight = document.documentElement.style.getPropertyValue(
    '--announcement-bar-height',
  );
  const scrollOffset = announcementBarHeight
    ? parseInt(announcementBarHeight.replace('px', ''))
    : 0;

  if (backgroundContainer) {
    const resizeCallback = throttle(
      () =>
        document.documentElement.style.setProperty(
          '--header-height',
          `${backgroundContainer.clientHeight}px`,
        ),
      500,
    );
    resizeCallback();
    window.addEventListener('resize', resizeCallback);

    if (typeof backgroundContainer.dataset.transparent !== 'undefined') {
      const scrollCallback = throttle(() => {
        if (sectionContainer.querySelector('.mobile-menu__container.open'))
          return;
        backgroundContainer.dataset.transparent =
          window.scrollY <= scrollOffset * 2;
      }, 500);
      scrollCallback();
      window.addEventListener('scroll', scrollCallback);
    }
  }

  const cartIcon = sectionContainer.querySelector('.header__action--cart');
  const minicart = document.querySelector('#MinicartDrawer');
  if (cartIcon && minicart)
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(minicart);
    });

  const cartCounter = sectionContainer.querySelector(
    '.header__action-cart-counter',
  );
  if (cartCounter) {
    document.addEventListener(afterCartChangeType, async () => {
      const cart = await getCart();
      if (cart) {
        cartCounter.innerText = cart.item_count;

        if (cart.item_count > 0) {
          cartCounter.style.display = 'flex';
        } else {
          cartCounter.style.display = 'none';
        }
      }
    });
  }

  const searchWrapper = sectionContainer.querySelector('.header__search');
  const searchIcon = sectionContainer.querySelector('.header__action--search');
  if (searchWrapper && searchIcon) {
    const mainInput = searchWrapper.querySelector('input[name="q"]');
    const closeWrapper = searchWrapper.querySelector('.header__search-close');
    if (mainInput && closeWrapper) {
      const closeSearch = () => {
        backgroundContainer.dataset.searchOpen = 'false';
        mainInput.value = '';
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
      };
      closeWrapper.addEventListener('click', closeSearch);
      searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        if (backgroundContainer.dataset.searchOpen == 'true') {
          closeSearch();
        } else {
          backgroundContainer.dataset.searchOpen = 'true';
          mainInput.focus();

          const openMobileMenu = sectionContainer.querySelector(
            '.mobile-menu__container',
          );
          if (openMobileMenu) {
            const modal = openMobileMenu.querySelector('.modal');
            openMobileMenu.classList.remove('open');
            closeModal(modal);
          }
        }
      });
    }
  }

  if (window.innerWidth >= parseInt(breakpoints.lg)) {
    const bigLogo = context.querySelector('.header__big-logo');

    if (bigLogo) {
      const allSections = document.querySelectorAll('main .shopify-section');
      const firstSection = allSections[0];
      const smallLogo = context.querySelector('.header__logo');

      allSections.forEach((section, index) => {
        if (index !== 0) {
          section.style.position = 'relative';
          section.style.zIndex = 2;
        }
      });

      if (firstSection) {
        firstSection.insertAdjacentElement('afterbegin', bigLogo);
        bigLogo.style.opacity = 1;
      }

      function handleLogoScroll() {
        const scrolledPast = window.scrollY > window.innerHeight * 1.3;

        if (scrolledPast) {
          bigLogo.style.opacity = 0;
          bigLogo.classList.remove('active');
          bigLogo.style.pointerEvents = 'none';
        } else {
          bigLogo.style.opacity = 1;
          bigLogo.classList.add('active');
          bigLogo.style.pointerEvents = 'auto';
        }

        smallLogo.classList.toggle('hidden', !scrolledPast);
      }

      window.addEventListener('scroll', handleLogoScroll);
      handleLogoScroll();
    }
  }

  let lastScrollPosition = 0;

  window.addEventListener('scroll', () => {
    const currentScrollPosition = window.scrollY;
    const plpStrip = document.querySelector('.collection-page__strip-wrapper');
    const searchStrip = document.querySelector(
      '.search-page__container .search-bar__container',
    );
    const legalStrip = document.querySelector(
      '.accordion.legal-page__navigation',
    );
    const translateYValue = `${backgroundContainer.clientHeight}px`;

    const isScrollingDown = currentScrollPosition > lastScrollPosition;
    const isInOffsetRange = currentScrollPosition <= scrollOffset * 1.5;

    if (isInOffsetRange) {
      backgroundContainer.style.transform = 'translateY(0)';
      if (plpStrip) {
        plpStrip.style.top = translateYValue;
      }
      if (searchStrip) {
        searchStrip.style.top = translateYValue;
      }
      if (legalStrip) {
        legalStrip.style.top = translateYValue;
      }
    } else {
      backgroundContainer.style.transform = isScrollingDown
        ? `translateY(-${translateYValue})`
        : 'translateY(0)';
      if (plpStrip) {
        plpStrip.style.top = isScrollingDown ? '0px' : translateYValue;
        plpStrip.style.zIndex = isScrollingDown ? '3' : '1';
      }
      if (searchStrip) {
        searchStrip.style.top = isScrollingDown ? '0px' : translateYValue;
      }
      if (legalStrip) {
        legalStrip.style.top = isScrollingDown ? '0px' : translateYValue;
      }
    }

    lastScrollPosition = currentScrollPosition;
  });
};

execOnLoad(window.dAgency.initHeader, '.header__section');
